var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tab-change-button" } }, [
    _c("div", { staticClass: "button-container" }, [
      _vm.prevButton
        ? _c(
            "div",
            { staticClass: "button back", on: { click: _vm.prevPage } },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.nextButton
        ? _c(
            "div",
            { staticClass: "button next", on: { click: _vm.nextPage } },
            [_c("md-icon", [_vm._v("arrow_forward")])],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }